class MySpeechEvent {

    constructor(eventname, time, runtimeTranscription, transcription) {
        this.eventname = eventname;
        this.time = time;
        this.runtimeTranscription = runtimeTranscription;
        this.transcription = transcription;
        
    }

}

export { MySpeechEvent }